import { useEffect, useState } from "react";
import { comics } from "@/mocks/comics";

const navLinks = [
  { label: "热门推荐", href: "#featured" },
  { label: "分类浏览", href: "#categories" },
  { label: "每日更新", href: "#updates" },
  { label: "人气榜单", href: "#ranking" },
  { label: "阅读指南", href: "#features" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [result, setResult] = useState<typeof comics>([]);
  const [showDrop, setShowDrop] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (!keyword.trim()) {
      setResult([]);
      return;
    }
    const kw = keyword.trim().toLowerCase();
    setResult(
      comics.filter(
        (c) =>
          c.title.toLowerCase().includes(kw) ||
          c.category.includes(keyword.trim()) ||
          c.tags.some((t) => t.includes(keyword.trim()))
      )
    );
  }, [keyword]);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || menuOpen
          ? "bg-background-950/90 backdrop-blur-md border-b border-background-800/70"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex items-center gap-4 px-4 md:px-8 h-16 md:h-[72px]">
        {/* 品牌 */}
        <a href="#top" className="flex items-center gap-2 shrink-0 cursor-pointer">
          <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-600 text-background-950">
            <i className="ri-book-open-fill text-xl md:text-2xl" />
          </span>
          <span className="font-heading text-xl md:text-2xl font-bold text-foreground-50 tracking-wide">
            韩漫<span className="text-primary-400">馆</span>
          </span>
        </a>

        {/* 桌面导航 */}
        <nav className="hidden lg:flex items-center gap-1 ml-4">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-300 hover:text-primary-300 hover:bg-background-800/60 transition-colors cursor-pointer"
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* 搜索框 */}
        <div className="relative hidden md:block flex-1 max-w-xs ml-auto">
          <div className="flex items-center gap-2 rounded-full bg-background-900 border border-background-700/70 focus-within:border-primary-500/60 px-3 py-2">
            <i className="ri-search-line text-foreground-400" />
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onFocus={() => setShowDrop(true)}
              onBlur={() => setTimeout(() => setShowDrop(false), 150)}
              placeholder="搜索韩漫或分类"
              className="w-full bg-transparent text-sm text-foreground-100 placeholder-foreground-500 outline-none"
            />
          </div>
          {showDrop && result.length > 0 && (
            <div className="absolute top-full mt-2 w-full rounded-lg bg-background-900 border border-background-700 overflow-hidden z-20">
              {result.map((c) => (
                <a
                  key={c.id}
                  href="#featured"
                  className="flex items-center gap-3 px-3 py-2.5 hover:bg-background-800 transition-colors cursor-pointer"
                >
                  <img src={c.cover} alt={c.title} className="w-8 h-11 rounded object-cover object-top" />
                  <div className="min-w-0">
                    <p className="text-sm text-foreground-100 truncate">{c.title}</p>
                    <p className="text-xs text-foreground-500">{c.category}</p>
                  </div>
                </a>
              ))}
            </div>
          )}
        </div>

        {/* 移动端汉堡 */}
        <button
          onClick={() => setMenuOpen((v) => !v)}
          className="ml-auto md:ml-0 lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-100 hover:bg-background-800 cursor-pointer"
          aria-label="打开菜单"
        >
          <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-3-line text-2xl"} />
        </button>
      </div>

      {/* 移动端菜单 */}
      {menuOpen && (
        <div className="lg:hidden bg-background-950/95 border-t border-background-800 px-4 py-4">
          <div className="relative mb-4">
            <div className="flex items-center gap-2 rounded-full bg-background-900 border border-background-700 px-3 py-2">
              <i className="ri-search-line text-foreground-400" />
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索韩漫或分类"
                className="w-full bg-transparent text-sm text-foreground-100 outline-none"
              />
            </div>
          </div>
          <nav className="grid grid-cols-2 gap-2">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md bg-background-900 px-3 py-2.5 text-sm text-foreground-200 text-center hover:text-primary-300 transition-colors cursor-pointer"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}